import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Outlet } from 'react-router-dom';

const ProtectedOutlet = withAuthenticationRequired(Outlet);

export default function ProtectedRoute() {
  return <ProtectedOutlet />;
}
